import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";

interface LoadingScreenProps {
  onComplete: () => void;
}

export const LoadingScreen = ({ onComplete }: LoadingScreenProps) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 800);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div
      className={`fixed inset-0 z-[100] flex items-center justify-center ${isDark ? "bg-[#0a0a0f]" : "bg-white"}`}
      initial={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: { duration: 0.8, ease: [0.65, 0, 0.35, 1] }
      }}
    >
      <motion.div
        initial={{ opacity: 0, filter: "blur(10px)", scale: 0.95 }}
        animate={{ opacity: 1, filter: "blur(0px)", scale: 1 }}
        transition={{ duration: 1, ease: [0.21, 0.47, 0.32, 0.98] }}
        className="relative"
      >
        <h1 className={`text-4xl md:text-5xl font-bold tracking-widest uppercase ${isDark ? "text-white" : "text-slate-900"}`}>
          Charcrith
        </h1>
        <motion.div
          className="absolute -bottom-4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500 to-transparent"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        />
      </motion.div>
    </motion.div>
  );
};
